module.exports = __webpack_public_path__ + "img/storage_1000.2868d34d.jpg";